<template>
  <el-dialog
    :title="$t('partnerPool.edit')"
    :visible.sync="dialogVisible"
    width="70%"
    @close="closeDialog"
  >
    <el-form label-width="120px">
      <el-form-item :label="$t('partnerPool.name')" required>
        <el-input
          v-model="editPartnerPoolInfo.partnerName"
          :placeholder="$t('partnerPool.requiredName')"
        ></el-input>
      </el-form-item>

      <el-form-item :label="$t('partnerPool.partner')" required>
        <el-select
          v-model="editPartnerPoolInfo.partnerType"
          :placeholder="$t('partnerPool.requiredPartner')"
          style="width:100%"
          disabled
        >
          <el-option
            v-for="(item,index) in editPartnerPoolInfo.partnerTypes"
            :key="index"
            :label="item.name"
            :value="item.partnerType"
          ></el-option>
        </el-select>
      </el-form-item>

      <el-form-item
        v-for="(item,index) in editPartnerPoolInfo.partnerKeys"
        :key="index"
        :label="item.name"
      >
        <el-input
          type="textarea"
          v-model="item.columnValue"
          :placeholder="item.remark"
        ></el-input>
      </el-form-item>

      <el-form-item :label="$t('partnerPool.status')" required>
        <el-select
          v-model="editPartnerPoolInfo.state"
          :placeholder="$t('partnerPool.requiredStatus')"
          style="width:100%"
        >
          <el-option
            :label="$t('partnerPool.enable')"
            value="Y"
          ></el-option>
          <el-option
            :label="$t('partnerPool.disable')"
            value="N"
          ></el-option>
        </el-select>
      </el-form-item>

      <el-form-item :label="$t('partnerPool.usage')">
        <el-input
          type="textarea"
          v-model="editPartnerPoolInfo.remark"
          :placeholder="$t('partnerPool.optionalUsage')"
        ></el-input>
      </el-form-item>
    </el-form>

    <span slot="footer" class="dialog-footer">
      <el-button @click="closeDialog">{{ $t('common.cancel') }}</el-button>
      <el-button type="primary" @click="editPartnerPool">
        {{ $t('common.save') }}
      </el-button>
    </span>
  </el-dialog>
</template>

<script>
import { updatePartnerPool, listPartnerKey, listPartnerAdapt, listPartnerPool } from '@/api/partner/partnerApi'
import { getShopId } from '@/api/shop/shopApi'

export default {
  name: 'EditPartnerPool',
  data() {
    return {
      dialogVisible: false,
      editPartnerPoolInfo: {
        ppId: '',
        partnerName: '',
        partnerType: '',
        state: '',
        remark: '',
        partnerTypes: [],
        partnerKeys: [],
        configIds: []
      }
    }
  },
  methods: {
    open(partnerPool) {
      this.refreshEditPartnerPoolInfo()
      Object.assign(this.editPartnerPoolInfo, partnerPool)
      this._loadEditPartnerAdapt()
      this._editChangeToType()
      this.dialogVisible = true
    },
    closeDialog() {
      this.dialogVisible = false
      this.refreshEditPartnerPoolInfo()
    },
    async editPartnerPool() {
      if (!this.editPartnerPoolValidate()) {
        this.$message.error(this.$t('partnerPool.validateError'))
        return
      }

      this.editPartnerPoolInfo.shopId = getShopId()

      try {
        const res = await updatePartnerPool(this.editPartnerPoolInfo)
        if (res.code === 0) {
          this.$message.success(this.$t('partnerPool.saveSuccess'))
          this.closeDialog()
          this.$emit('refresh')
        } else {
          this.$message.error(res.msg)
        }
      } catch (error) {
        this.$message.error(this.$t('partnerPool.saveFailed'))
      }
    },
    refreshEditPartnerPoolInfo() {
      const partnerTypes = this.editPartnerPoolInfo.partnerTypes
      console.log(partnerTypes)
      this.editPartnerPoolInfo = {
        ppId: '',
        partnerName: '',
        partnerType: '',
        partnerTypes: partnerTypes,
        state: '',
        remark: '',
        partnerKeys: [],
        configIds: []
      }
    },
    editPartnerPoolValidate() {
      if (!this.editPartnerPoolInfo.partnerName) {
        return false
      }
      if (!this.editPartnerPoolInfo.partnerType) {
        return false
      }
      if (!this.editPartnerPoolInfo.state) {
        return false
      }
      if (!this.editPartnerPoolInfo.ppId) {
        return false
      }
      return true
    },
    async _editChangeToType() {
      if (!this.editPartnerPoolInfo.partnerType) return

      try {
        const res = await listPartnerKey({
          partnerType: this.editPartnerPoolInfo.partnerType,
          page: 1,
          row: 100
        })
        this.editPartnerPoolInfo.partnerKeys = res.data.map(item => ({
          ...item,
          columnValue: ''
        }))
        await this._editLoadPartnerData()
      } catch (error) {
        console.error('请求失败处理', error)
      }
    },
    async _loadEditPartnerAdapt() {
      try {
        const res = await listPartnerAdapt({
          page: 1,
          row: 100
        })
        this.editPartnerPoolInfo.partnerTypes = res.data
      } catch (error) {
        console.error('请求失败处理', error)
      }
    },
    async _editLoadPartnerData() {
      try {
        const res = await listPartnerPool({
          page: 1,
          row: 1,
          shopId: getShopId(),
          ppId: this.editPartnerPoolInfo.ppId
        })
        
        const values = res.data[0].values
        values.forEach(value => {
          this.editPartnerPoolInfo.partnerKeys.forEach(key => {
            if (value.columnKey === key.columnKey) {
              key.columnValue = value.columnValue
            }
          })
        })

        const configs = res.data[0].configs || []
        this.editPartnerPoolInfo.configIds = configs.map(config => config.configId)
      } catch (error) {
        console.error('请求失败处理', error)
      }
    }
  }
}
</script>